//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IVNextClient {

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto>;

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]>;

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
     addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto>;
     
     /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void>;
}

export class VNextClient implements IVNextClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/OldAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOldAuthenticate(_response);
        });
    }

    protected processOldAuthenticate(response: Response): Promise<AuthenticatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/Employee/VNext/all?";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
    
    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/byAzureObjId?";
        if (azureObjId === null)
            throw new Error("The parameter 'azureObjId' cannot be null.");
        else if (azureObjId !== undefined)
            url_ += "azureObjId=" + encodeURIComponent("" + azureObjId) + "&";
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeByAzureObjId(_response);
        });
    }

    protected processGetEmployeeByAzureObjId(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }
    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/myInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: Response): Promise<EmployeeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployee(_response);
        });
    }

    protected processAddNewEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }    

    /**
     * @param body (optional) 
     * @return Success
     */
     addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/EmployeeAccount";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeAccount(_response);
        });
    }

    protected processAddNewEmployeeAccount(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/JobPosition";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewJobPosition(_response);
        });
    }

    protected processAddNewJobPosition(response: Response): Promise<JobPositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedRequestResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JobPosition/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobPosition(_response);
        });
    }

    protected processDeleteJobPosition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export interface IVNextArmClient {

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto>;

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]>;

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
     addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto>;
     
     /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void>;
}

export class VNextArmClient implements IVNextArmClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/OldAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOldAuthenticate(_response);
        });
    }

    protected processOldAuthenticate(response: Response): Promise<AuthenticatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/Employee/VNext/all?";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
    
    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/byAzureObjId?";
        if (azureObjId === null)
            throw new Error("The parameter 'azureObjId' cannot be null.");
        else if (azureObjId !== undefined)
            url_ += "azureObjId=" + encodeURIComponent("" + azureObjId) + "&";
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeByAzureObjId(_response);
        });
    }

    protected processGetEmployeeByAzureObjId(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/myInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: Response): Promise<EmployeeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployee(_response);
        });
    }

    protected processAddNewEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
     addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/EmployeeAccount";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeAccount(_response);
        });
    }

    protected processAddNewEmployeeAccount(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/JobPosition";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewJobPosition(_response);
        });
    }

    protected processAddNewJobPosition(response: Response): Promise<JobPositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedRequestResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JobPosition/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobPosition(_response);
        });
    }

    protected processDeleteJobPosition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class AlarmDto implements IAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;

    constructor(data?: IAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
}

export class AlarmTimeSpan implements IAlarmTimeSpan {
    months!: number;
    days!: number;
    hours!: number;

    constructor(data?: IAlarmTimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.months = _data["months"];
            this.days = _data["days"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): AlarmTimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["months"] = this.months;
        data["days"] = this.days;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IAlarmTimeSpan {
    months: number;
    days: number;
    hours: number;
}

export enum AlarmType {
    TimeAlarm = "TimeAlarm",
    KmAlarm = "KmAlarm",
}

export class Angle implements IAngle {
    value!: number;
    unit!: AngleUnit;

    constructor(data?: IAngle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Angle {
        data = typeof data === 'object' ? data : {};
        let result = new Angle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IAngle {
    value: number;
    unit: AngleUnit;
}

export enum AngleOffsetType {
    None = "None",
    MinusAlpha = "MinusAlpha",
    PIHalfMinusAlpha = "PIHalfMinusAlpha",
    PiMinusAlpha = "PiMinusAlpha",
    MinusPIHalfMinusAlpha = "MinusPIHalfMinusAlpha",
}

export enum AngleUnit {
    Degree = "Degree",
    Radians = "Radians",
}

export class ArmActionsExecutedStatsResultDto implements IArmActionsExecutedStatsResultDto {
    statDate!: Date;
    data!: ArmatureActionTypeTimePointManyNumberStat[] | undefined;

    constructor(data?: IArmActionsExecutedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArmatureActionTypeTimePointManyNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmActionsExecutedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmActionsExecutedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmActionsExecutedStatsResultDto {
    statDate: Date;
    data: ArmatureActionTypeTimePointManyNumberStat[] | undefined;
}

export enum ArmatureActionType {
    ArmBent = "ArmBent",
    ArmLoaded = "ArmLoaded",
}

export class ArmatureActionTypeTimePointManyNumberStat implements IArmatureActionTypeTimePointManyNumberStat {
    date!: Date;
    stat!: { [key: string]: number; } | undefined;

    constructor(data?: IArmatureActionTypeTimePointManyNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (_data["stat"]) {
                this.stat = {} as any;
                for (let key in _data["stat"]) {
                    if (_data["stat"].hasOwnProperty(key))
                        (<any>this.stat)![key] = _data["stat"][key];
                }
            }
        }
    }

    static fromJS(data: any): ArmatureActionTypeTimePointManyNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new ArmatureActionTypeTimePointManyNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.stat) {
            data["stat"] = {};
            for (let key in this.stat) {
                if (this.stat.hasOwnProperty(key))
                    (<any>data["stat"])[key] = (<any>this.stat)[key];
            }
        }
        return data;
    }
}

export interface IArmatureActionTypeTimePointManyNumberStat {
    date: Date;
    stat: { [key: string]: number; } | undefined;
}

export enum ArmCardColor {
    White = "White",
    Yellow = "Yellow",
    Orange = "Orange",
    Red = "Red",
    Green = "Green",
    Blue = "Blue",
    DarkBlue = "DarkBlue",
    Pink = "Pink",
    Brown = "Brown",
    Beige = "Beige",
}

export class ArmCardDto implements IArmCardDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    armOrderItemTaskId!: number;
    status!: ArmCardStatus;
    reason!: string | undefined;
    sguid!: string | undefined;
    stripColor!: ArmCardColor;

    constructor(data?: IArmCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.armOrderItemTaskId = _data["armOrderItemTaskId"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.sguid = _data["sguid"];
            this.stripColor = _data["stripColor"];
        }
    }

    static fromJS(data: any): ArmCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["armOrderItemTaskId"] = this.armOrderItemTaskId;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["sguid"] = this.sguid;
        data["stripColor"] = this.stripColor;
        return data;
    }
}

export interface IArmCardDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    armOrderItemTaskId: number;
    status: ArmCardStatus;
    reason: string | undefined;
    sguid: string | undefined;
    stripColor: ArmCardColor;
}

export class ArmCardsCreatedStatsResultDto implements IArmCardsCreatedStatsResultDto {
    statDate!: Date;
    data!: TimePointNumberStat[] | undefined;

    constructor(data?: IArmCardsCreatedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimePointNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmCardsCreatedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmCardsCreatedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmCardsCreatedStatsResultDto {
    statDate: Date;
    data: TimePointNumberStat[] | undefined;
}

export enum ArmCardStatus {
    Active = "Active",
    Cancelled = "Cancelled",
}

export class ArmItemsCreatedStatsResultDto implements IArmItemsCreatedStatsResultDto {
    statDate!: Date;
    data!: TimePointUserNumberStat[] | undefined;

    constructor(data?: IArmItemsCreatedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimePointUserNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmItemsCreatedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsCreatedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmItemsCreatedStatsResultDto {
    statDate: Date;
    data: TimePointUserNumberStat[] | undefined;
}

export class ArmItemsFinishedByWorkerDto implements IArmItemsFinishedByWorkerDto {
    date!: Date;
    data!: ArmOrderItemDto[] | undefined;

    constructor(data?: IArmItemsFinishedByWorkerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArmOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmItemsFinishedByWorkerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsFinishedByWorkerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmItemsFinishedByWorkerDto {
    date: Date;
    data: ArmOrderItemDto[] | undefined;
}

export class ArmItemsFinishedByWorkerResultDto implements IArmItemsFinishedByWorkerResultDto {
    statDate!: Date;
    data!: { [key: string]: ArmItemsFinishedByWorkerDto[]; } | undefined;

    constructor(data?: IArmItemsFinishedByWorkerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key] ? _data["data"][key].map((i: any) => ArmItemsFinishedByWorkerDto.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ArmItemsFinishedByWorkerResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsFinishedByWorkerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IArmItemsFinishedByWorkerResultDto {
    statDate: Date;
    data: { [key: string]: ArmItemsFinishedByWorkerDto[]; } | undefined;
}

export class ArmModelDto implements IArmModelDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    tags!: string | undefined;
    armTemplate!: ArmTemplate;
    isDeleted!: boolean;

    constructor(data?: IArmModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.tags = _data["tags"];
            this.armTemplate = _data["armTemplate"] ? ArmTemplate.fromJS(_data["armTemplate"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ArmModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["tags"] = this.tags;
        data["armTemplate"] = this.armTemplate ? this.armTemplate.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IArmModelDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    tags: string | undefined;
    armTemplate: ArmTemplate;
    isDeleted: boolean;
}

export class ArmOrderDto implements IArmOrderDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    clientOrderNumber!: number;
    clientId!: number;
    constructionSiteId!: number;
    client!: ClientDto;
    constructionSite!: ConstructionSiteDto;
    items!: ArmOrderItemDto[] | undefined;
    title!: string | undefined;
    description!: string | undefined;
    status!: ArmOrderStatus;

    constructor(data?: IArmOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.clientOrderNumber = _data["clientOrderNumber"];
            this.clientId = _data["clientId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.constructionSite = _data["constructionSite"] ? ConstructionSiteDto.fromJS(_data["constructionSite"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArmOrderItemDto.fromJS(item));
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ArmOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["clientOrderNumber"] = this.clientOrderNumber;
        data["clientId"] = this.clientId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["constructionSite"] = this.constructionSite ? this.constructionSite.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IArmOrderDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    clientOrderNumber: number;
    clientId: number;
    constructionSiteId: number;
    client: ClientDto;
    constructionSite: ConstructionSiteDto;
    items: ArmOrderItemDto[] | undefined;
    title: string | undefined;
    description: string | undefined;
    status: ArmOrderStatus;
}

export class ArmOrderItemDto implements IArmOrderItemDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    internalOrderId!: number;
    orderId!: number;
    armModelTemplateId!: number;
    armModelTemplateParameters!: ArmTemplateParameters;
    position!: string | undefined;
    positionIndex!: string | undefined;
    diameter!: number;
    quantity!: number;
    status!: ArmOrderItemStatus;
    armModelTemplate!: ArmModelDto;

    constructor(data?: IArmOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.internalOrderId = _data["internalOrderId"];
            this.orderId = _data["orderId"];
            this.armModelTemplateId = _data["armModelTemplateId"];
            this.armModelTemplateParameters = _data["armModelTemplateParameters"] ? ArmTemplateParameters.fromJS(_data["armModelTemplateParameters"]) : <any>undefined;
            this.position = _data["position"];
            this.positionIndex = _data["positionIndex"];
            this.diameter = _data["diameter"];
            this.quantity = _data["quantity"];
            this.status = _data["status"];
            this.armModelTemplate = _data["armModelTemplate"] ? ArmModelDto.fromJS(_data["armModelTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["internalOrderId"] = this.internalOrderId;
        data["orderId"] = this.orderId;
        data["armModelTemplateId"] = this.armModelTemplateId;
        data["armModelTemplateParameters"] = this.armModelTemplateParameters ? this.armModelTemplateParameters.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["positionIndex"] = this.positionIndex;
        data["diameter"] = this.diameter;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["armModelTemplate"] = this.armModelTemplate ? this.armModelTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    internalOrderId: number;
    orderId: number;
    armModelTemplateId: number;
    armModelTemplateParameters: ArmTemplateParameters;
    position: string | undefined;
    positionIndex: string | undefined;
    diameter: number;
    quantity: number;
    status: ArmOrderItemStatus;
    armModelTemplate: ArmModelDto;
}

export class ArmOrderItemProductionDataDto implements IArmOrderItemProductionDataDto {
    armOrderItem!: ArmOrderItemDto;
    armOrderItemTask!: ArmOrderItemTaskDto;

    constructor(data?: IArmOrderItemProductionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
            this.armOrderItemTask = _data["armOrderItemTask"] ? ArmOrderItemTaskDto.fromJS(_data["armOrderItemTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemProductionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemProductionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        data["armOrderItemTask"] = this.armOrderItemTask ? this.armOrderItemTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemProductionDataDto {
    armOrderItem: ArmOrderItemDto;
    armOrderItemTask: ArmOrderItemTaskDto;
}

export enum ArmOrderItemStatus {
    New = "New",
}

export class ArmOrderItemTaskDto implements IArmOrderItemTaskDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    armOrderItemId!: number;
    status!: ArmOrderItemTaskStatus;
    cards!: ArmCardDto[] | undefined;
    armOrderItem!: ArmOrderItemDto;

    constructor(data?: IArmOrderItemTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.armOrderItemId = _data["armOrderItemId"];
            this.status = _data["status"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(ArmCardDto.fromJS(item));
            }
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["armOrderItemId"] = this.armOrderItemId;
        data["status"] = this.status;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemTaskDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    armOrderItemId: number;
    status: ArmOrderItemTaskStatus;
    cards: ArmCardDto[] | undefined;
    armOrderItem: ArmOrderItemDto;
}

export enum ArmOrderItemTaskStatus {
    New = "New",
    Active = "Active",
    Bent = "Bent",
    Loaded = "Loaded",
    Completed = "Completed",
}

export class ArmOrderProductionDataDto implements IArmOrderProductionDataDto {
    armOrder!: ArmOrderDto;
    itemsCount!: number;
    itemsInProduction!: number;
    itemsBent!: number;
    itemsDeployed!: number;

    constructor(data?: IArmOrderProductionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            this.itemsCount = _data["itemsCount"];
            this.itemsInProduction = _data["itemsInProduction"];
            this.itemsBent = _data["itemsBent"];
            this.itemsDeployed = _data["itemsDeployed"];
        }
    }

    static fromJS(data: any): ArmOrderProductionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderProductionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        data["itemsCount"] = this.itemsCount;
        data["itemsInProduction"] = this.itemsInProduction;
        data["itemsBent"] = this.itemsBent;
        data["itemsDeployed"] = this.itemsDeployed;
        return data;
    }
}

export interface IArmOrderProductionDataDto {
    armOrder: ArmOrderDto;
    itemsCount: number;
    itemsInProduction: number;
    itemsBent: number;
    itemsDeployed: number;
}

export class ArmOrderProductionDetailDataDto implements IArmOrderProductionDetailDataDto {
    armOrder!: ArmOrderDto;
    items!: ArmOrderItemProductionDataDto[] | undefined;
    infoDate!: Date;

    constructor(data?: IArmOrderProductionDetailDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArmOrderItemProductionDataDto.fromJS(item));
            }
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderProductionDetailDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderProductionDetailDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArmOrderProductionDetailDataDto {
    armOrder: ArmOrderDto;
    items: ArmOrderItemProductionDataDto[] | undefined;
    infoDate: Date;
}

export enum ArmOrderStatus {
    New = "New",
    Pending = "Pending",
    Active = "Active",
    Cancelled = "Cancelled",
    Completed = "Completed",
}

export class ArmParameter implements IArmParameter {
    unitType!: UnitType;
    defaultValue!: any | undefined;
    metadata!: ArmParameterMetadata;

    constructor(data?: IArmParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.defaultValue = _data["defaultValue"];
            this.metadata = _data["metadata"] ? ArmParameterMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["defaultValue"] = this.defaultValue;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmParameter {
    unitType: UnitType;
    defaultValue: any | undefined;
    metadata: ArmParameterMetadata;
}

export class ArmParameterMetadata implements IArmParameterMetadata {
    description!: string | undefined;
    origin!: ArmParameterOrigin;

    constructor(data?: IArmParameterMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.origin = _data["origin"] ? ArmParameterOrigin.fromJS(_data["origin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmParameterMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmParameterMetadata {
    description: string | undefined;
    origin: ArmParameterOrigin;
}

export class ArmParameterOrigin implements IArmParameterOrigin {
    sectionId!: string | undefined;
    sectionParamId!: string | undefined;

    constructor(data?: IArmParameterOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionParamId = _data["sectionParamId"];
        }
    }

    static fromJS(data: any): ArmParameterOrigin {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterOrigin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionParamId"] = this.sectionParamId;
        return data;
    }
}

export interface IArmParameterOrigin {
    sectionId: string | undefined;
    sectionParamId: string | undefined;
}

export class ArmParameterValue implements IArmParameterValue {
    unitType!: UnitType;
    value!: any | undefined;

    constructor(data?: IArmParameterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ArmParameterValue {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["value"] = this.value;
        return data;
    }
}

export interface IArmParameterValue {
    unitType: UnitType;
    value: any | undefined;
}

export class ArmProductionDetailDataDto implements IArmProductionDetailDataDto {
    orders!: ArmOrderProductionDataDto[] | undefined;
    infoDate!: Date;

    constructor(data?: IArmProductionDetailDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ArmOrderProductionDataDto.fromJS(item));
            }
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmProductionDetailDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmProductionDetailDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArmProductionDetailDataDto {
    orders: ArmOrderProductionDataDto[] | undefined;
    infoDate: Date;
}

export class ArmSection implements IArmSection {
    id!: string | undefined;
    sectionType!: SectionType;
    parameters!: { [key: string]: SectionParameter; } | undefined;

    constructor(data?: IArmSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionType = _data["sectionType"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] ? SectionParameter.fromJS(_data["parameters"][key]) : new SectionParameter();
                }
            }
        }
    }

    static fromJS(data: any): ArmSection {
        data = typeof data === 'object' ? data : {};
        let result = new ArmSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionType"] = this.sectionType;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IArmSection {
    id: string | undefined;
    sectionType: SectionType;
    parameters: { [key: string]: SectionParameter; } | undefined;
}

export class ArmTemplate implements IArmTemplate {
    parameters!: { [key: string]: ArmParameter; } | undefined;
    variables!: { [key: string]: ArmVariable; } | undefined;
    sections!: ArmSection[] | undefined;

    constructor(data?: IArmTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] ? ArmParameter.fromJS(_data["parameters"][key]) : new ArmParameter();
                }
            }
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (<any>this.variables)![key] = _data["variables"][key] ? ArmVariable.fromJS(_data["variables"][key]) : new ArmVariable();
                }
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ArmSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ArmTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
            }
        }
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (<any>data["variables"])[key] = this.variables[key] ? this.variables[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmTemplate {
    parameters: { [key: string]: ArmParameter; } | undefined;
    variables: { [key: string]: ArmVariable; } | undefined;
    sections: ArmSection[] | undefined;
}

export class ArmTemplateParameters implements IArmTemplateParameters {
    parametersValues!: { [key: string]: ArmParameterValue; } | undefined;

    constructor(data?: IArmTemplateParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["parametersValues"]) {
                this.parametersValues = {} as any;
                for (let key in _data["parametersValues"]) {
                    if (_data["parametersValues"].hasOwnProperty(key))
                        (<any>this.parametersValues)![key] = _data["parametersValues"][key] ? ArmParameterValue.fromJS(_data["parametersValues"][key]) : new ArmParameterValue();
                }
            }
        }
    }

    static fromJS(data: any): ArmTemplateParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ArmTemplateParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.parametersValues) {
            data["parametersValues"] = {};
            for (let key in this.parametersValues) {
                if (this.parametersValues.hasOwnProperty(key))
                    (<any>data["parametersValues"])[key] = this.parametersValues[key] ? this.parametersValues[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IArmTemplateParameters {
    parametersValues: { [key: string]: ArmParameterValue; } | undefined;
}

export class ArmVariable implements IArmVariable {
    unitType!: UnitType;
    variableType!: VariableType;
    value!: any | undefined;
    metadata!: ArmVariableMetadata;

    constructor(data?: IArmVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.variableType = _data["variableType"];
            this.value = _data["value"];
            this.metadata = _data["metadata"] ? ArmVariableMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmVariable {
        data = typeof data === 'object' ? data : {};
        let result = new ArmVariable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["variableType"] = this.variableType;
        data["value"] = this.value;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmVariable {
    unitType: UnitType;
    variableType: VariableType;
    value: any | undefined;
    metadata: ArmVariableMetadata;
}

export class ArmVariableMetadata implements IArmVariableMetadata {
    origin!: ArmParameterOrigin;

    constructor(data?: IArmVariableMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? ArmParameterOrigin.fromJS(_data["origin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmVariableMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ArmVariableMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmVariableMetadata {
    origin: ArmParameterOrigin;
}

export class AuthenticatedDto implements IAuthenticatedDto {
    employeeInfo!: EmployeeInfoDto;
    token!: string | undefined;
    expirationDate!: Date;

    constructor(data?: IAuthenticatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeInfo = _data["employeeInfo"] ? EmployeeInfoDto.fromJS(_data["employeeInfo"]) : <any>undefined;
            this.token = _data["token"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeInfo"] = this.employeeInfo ? this.employeeInfo.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthenticatedDto {
    employeeInfo: EmployeeInfoDto;
    token: string | undefined;
    expirationDate: Date;
}

export class BadRequestResponse implements IBadRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IBadRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): BadRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IBadRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export class CarDto implements ICarDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    productionDate!: Date;
    data!: any | undefined;
    engineType!: EngineType;

    constructor(data?: ICarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): CarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface ICarDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    productionDate: Date;
    data: any | undefined;
    engineType: EngineType;
}

export class ChangePasswordDto implements IChangePasswordDto {
    employeeAccount!: EmployeeAccountDto;
    newPassword!: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    employeeAccount: EmployeeAccountDto;
    newPassword: string | undefined;
}

export class ClientDocumentDto implements IClientDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    clientId!: number;

    constructor(data?: IClientDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ClientDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IClientDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    clientId: number;
}

export class ClientDto implements IClientDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    entityType!: EntityType;
    clientType!: ClientType;
    name!: string | undefined;
    shortName!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    ucin!: string | undefined;
    taxId!: string | undefined;
    contactInfo!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.clientType = _data["clientType"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.ucin = _data["ucin"];
            this.taxId = _data["taxId"];
            this.contactInfo = _data["contactInfo"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["clientType"] = this.clientType;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["ucin"] = this.ucin;
        data["taxId"] = this.taxId;
        data["contactInfo"] = this.contactInfo;
        data["email"] = this.email;
        return data;
    }
}

export interface IClientDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    entityType: EntityType;
    clientType: ClientType;
    name: string | undefined;
    shortName: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    city: string | undefined;
    ucin: string | undefined;
    taxId: string | undefined;
    contactInfo: string | undefined;
    email: string | undefined;
}

export class ClientRecordDto implements IClientRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    clientId!: number;

    constructor(data?: IClientRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ClientRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IClientRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    clientId: number;
}

export enum ClientType {
    Customer = "Customer",
    Service = "Service",
    Supplier = "Supplier",
}

export class CompositionDto implements ICompositionDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    mainVehicleId!: number;
    trailersIds!: number[] | undefined;
    workingMachinesIds!: number[] | undefined;
    data!: any | undefined;

    constructor(data?: ICompositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.mainVehicleId = _data["mainVehicleId"];
            if (Array.isArray(_data["trailersIds"])) {
                this.trailersIds = [] as any;
                for (let item of _data["trailersIds"])
                    this.trailersIds!.push(item);
            }
            if (Array.isArray(_data["workingMachinesIds"])) {
                this.workingMachinesIds = [] as any;
                for (let item of _data["workingMachinesIds"])
                    this.workingMachinesIds!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CompositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["mainVehicleId"] = this.mainVehicleId;
        if (Array.isArray(this.trailersIds)) {
            data["trailersIds"] = [];
            for (let item of this.trailersIds)
                data["trailersIds"].push(item);
        }
        if (Array.isArray(this.workingMachinesIds)) {
            data["workingMachinesIds"] = [];
            for (let item of this.workingMachinesIds)
                data["workingMachinesIds"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface ICompositionDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    mainVehicleId: number;
    trailersIds: number[] | undefined;
    workingMachinesIds: number[] | undefined;
    data: any | undefined;
}

export class ConcurrencyRequestResponse implements IConcurrencyRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IConcurrencyRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): ConcurrencyRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrencyRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IConcurrencyRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export class ConfigDto implements IConfigDto {
    googleConfig!: GoogleConfigDto;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleConfig = _data["googleConfig"] ? GoogleConfigDto.fromJS(_data["googleConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleConfig"] = this.googleConfig ? this.googleConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigDto {
    googleConfig: GoogleConfigDto;
}

export class ConstructionSiteDto implements IConstructionSiteDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    data!: any | undefined;
    locationInfo!: any | undefined;
    projectId!: number;
    project!: ProjectDto;

    constructor(data?: IConstructionSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.locationInfo = _data["locationInfo"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConstructionSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        data["data"] = this.data;
        data["locationInfo"] = this.locationInfo;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConstructionSiteDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    data: any | undefined;
    locationInfo: any | undefined;
    projectId: number;
    project: ProjectDto;
}

export enum ContactInfoType {
    Viber = "Viber",
}

export class CreateArmCardRequestDto implements ICreateArmCardRequestDto {
    reason!: string | undefined;
    stripColor!: ArmCardColor;

    constructor(data?: ICreateArmCardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.stripColor = _data["stripColor"];
        }
    }

    static fromJS(data: any): CreateArmCardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArmCardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["stripColor"] = this.stripColor;
        return data;
    }
}

export interface ICreateArmCardRequestDto {
    reason: string | undefined;
    stripColor: ArmCardColor;
}

export class DocumentDto implements IDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
}

export class DriverDto implements IDriverDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    azObjId!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;
    personalNumber!: string | undefined;
    ucin!: string | undefined;
    birthDate!: Date;
    employeeAccount!: EmployeeAccountDto;
    jobPositions!: JobPositionDto[] | undefined;
    contactInfos!: EmployeeContactInfoDto[] | undefined;
    data!: any | undefined;
    tcNumber!: string | undefined;
    driverPositionId!: number;
    driverPositionTimeStamp!: string | undefined;

    constructor(data?: IDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.azObjId = _data["azObjId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalNumber = _data["personalNumber"];
            this.ucin = _data["ucin"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            if (Array.isArray(_data["jobPositions"])) {
                this.jobPositions = [] as any;
                for (let item of _data["jobPositions"])
                    this.jobPositions!.push(JobPositionDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(EmployeeContactInfoDto.fromJS(item));
            }
            this.data = _data["data"];
            this.tcNumber = _data["tcNumber"];
            this.driverPositionId = _data["driverPositionId"];
            this.driverPositionTimeStamp = _data["driverPositionTimeStamp"];
        }
    }

    static fromJS(data: any): DriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["azObjId"] = this.azObjId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["personalNumber"] = this.personalNumber;
        data["ucin"] = this.ucin;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.jobPositions)) {
            data["jobPositions"] = [];
            for (let item of this.jobPositions)
                data["jobPositions"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        data["data"] = this.data;
        data["tcNumber"] = this.tcNumber;
        data["driverPositionId"] = this.driverPositionId;
        data["driverPositionTimeStamp"] = this.driverPositionTimeStamp;
        return data;
    }
}

export interface IDriverDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    azObjId: string | undefined;
    name: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    personalNumber: string | undefined;
    ucin: string | undefined;
    birthDate: Date;
    employeeAccount: EmployeeAccountDto;
    jobPositions: JobPositionDto[] | undefined;
    contactInfos: EmployeeContactInfoDto[] | undefined;
    data: any | undefined;
    tcNumber: string | undefined;
    driverPositionId: number;
    driverPositionTimeStamp: string | undefined;
}

export class EmployeeAccountDto implements IEmployeeAccountDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    employeeId!: number;
    username!: string | undefined;
    password!: string | undefined;

    constructor(data?: IEmployeeAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): EmployeeAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IEmployeeAccountDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    employeeId: number;
    username: string | undefined;
    password: string | undefined;
}

export class EmployeeContactInfoDto implements IEmployeeContactInfoDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    type!: ContactInfoType;
    contactId!: string | undefined;
    contactName!: string | undefined;
    contactAvatar!: string | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactAvatar = _data["contactAvatar"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["type"] = this.type;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactAvatar"] = this.contactAvatar;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeContactInfoDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    type: ContactInfoType;
    contactId: string | undefined;
    contactName: string | undefined;
    contactAvatar: string | undefined;
    employeeId: number;
}

export class EmployeeDocumentDto implements IEmployeeDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    employeeId: number;
}

export class EmployeeDto implements IEmployeeDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    azObjId!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;
    personalNumber!: string | undefined;
    ucin!: string | undefined;
    birthDate!: Date;
    employeeAccount!: EmployeeAccountDto;
    jobPositions!: JobPositionDto[] | undefined;
    contactInfos!: EmployeeContactInfoDto[] | undefined;
    data!: any | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.azObjId = _data["azObjId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalNumber = _data["personalNumber"];
            this.ucin = _data["ucin"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            if (Array.isArray(_data["jobPositions"])) {
                this.jobPositions = [] as any;
                for (let item of _data["jobPositions"])
                    this.jobPositions!.push(JobPositionDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(EmployeeContactInfoDto.fromJS(item));
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["azObjId"] = this.azObjId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["personalNumber"] = this.personalNumber;
        data["ucin"] = this.ucin;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.jobPositions)) {
            data["jobPositions"] = [];
            for (let item of this.jobPositions)
                data["jobPositions"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IEmployeeDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    azObjId: string | undefined;
    name: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    personalNumber: string | undefined;
    ucin: string | undefined;
    birthDate: Date;
    employeeAccount: EmployeeAccountDto;
    jobPositions: JobPositionDto[] | undefined;
    contactInfos: EmployeeContactInfoDto[] | undefined;
    data: any | undefined;
}

export class EmployeeInfoDto implements IEmployeeInfoDto {
    employee!: EmployeeDto;
    roles!: string[] | undefined;

    constructor(data?: IEmployeeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IEmployeeInfoDto {
    employee: EmployeeDto;
    roles: string[] | undefined;
}

export class EmployeeRecordDto implements IEmployeeRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    employeeId: number;
}

export enum EngineType {
    Gasoline = "Gasoline",
    Diesel = "Diesel",
    LNG = "LNG",
    LPG = "LPG",
    CNG = "CNG",
    Electric = "Electric",
}

export enum EntityType {
    Legal = "Legal",
    Physical = "Physical",
}

export class ExecuteActionRequestDto implements IExecuteActionRequestDto {
    actionCode!: string | undefined;
    onBehalfEmployee!: number;
    originated!: Date;

    constructor(data?: IExecuteActionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.onBehalfEmployee = _data["onBehalfEmployee"];
            this.originated = _data["originated"] ? new Date(_data["originated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExecuteActionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["onBehalfEmployee"] = this.onBehalfEmployee;
        data["originated"] = this.originated ? this.originated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExecuteActionRequestDto {
    actionCode: string | undefined;
    onBehalfEmployee: number;
    originated: Date;
}

export class ExecuteActionResponseDto implements IExecuteActionResponseDto {
    armOrderItem!: ArmOrderItemDto;
    armOrder!: ArmOrderDto;
    actionType!: ArmatureActionType;

    constructor(data?: IExecuteActionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): ExecuteActionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface IExecuteActionResponseDto {
    armOrderItem: ArmOrderItemDto;
    armOrder: ArmOrderDto;
    actionType: ArmatureActionType;
}

export enum ExpenseType {
    Fuel = "Fuel",
    Other = "Other",
}

export class GetProductionDataRefreshInfoResponseDto implements IGetProductionDataRefreshInfoResponseDto {
    infoDate!: Date | undefined;

    constructor(data?: IGetProductionDataRefreshInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductionDataRefreshInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionDataRefreshInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetProductionDataRefreshInfoResponseDto {
    infoDate: Date | undefined;
}

export class GoogleConfigDto implements IGoogleConfigDto {
    apiKey!: string | undefined;

    constructor(data?: IGoogleConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): GoogleConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IGoogleConfigDto {
    apiKey: string | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    description!: string | undefined;
    code!: string | undefined;
    creationDate!: Date;
    data!: any | undefined;
    clientId!: number;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["description"] = this.description;
        data["code"] = this.code;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IInvoiceDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    description: string | undefined;
    code: string | undefined;
    creationDate: Date;
    data: any | undefined;
    clientId: number;
}

export class JobPositionDto implements IJobPositionDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    employeeId!: number;
    jobPositionType!: JobPositionType;
    data!: any | undefined;

    constructor(data?: IJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.jobPositionType = _data["jobPositionType"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): JobPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["jobPositionType"] = this.jobPositionType;
        data["data"] = this.data;
        return data;
    }
}

export interface IJobPositionDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    employeeId: number;
    jobPositionType: JobPositionType;
    data: any | undefined;
}

export enum JobPositionType {
    Driver = "Driver",
    TransportOperator = "TransportOperator",
    ArmatureWorker = "ArmatureWorker",
    ArmatureOperator = "ArmatureOperator",
    SystemAdmin = "SystemAdmin",
    CEO = "CEO",
}

export class KmAlarmDto implements IKmAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;
    inKmToRing!: number | undefined;
    kmWhenToRing!: number | undefined;

    constructor(data?: IKmAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
            this.inKmToRing = _data["inKmToRing"];
            this.kmWhenToRing = _data["kmWhenToRing"];
        }
    }

    static fromJS(data: any): KmAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new KmAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        data["inKmToRing"] = this.inKmToRing;
        data["kmWhenToRing"] = this.kmWhenToRing;
        return data;
    }
}

export interface IKmAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
    inKmToRing: number | undefined;
    kmWhenToRing: number | undefined;
}

export class Length implements ILength {
    value!: number;
    unit!: LengthUnit;

    constructor(data?: ILength) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Length {
        data = typeof data === 'object' ? data : {};
        let result = new Length();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface ILength {
    value: number;
    unit: LengthUnit;
}

export enum LengthUnit {
    Meter = "Meter",
    Milimeter = "Milimeter",
    Centimeter = "Centimeter",
}

export enum MachineType {
    WorkingMachine = "WorkingMachine",
    HandMachine = "HandMachine",
    OfficeMachine = "OfficeMachine",
    WorkingTool = "WorkingTool",
}

export enum ParameterRefType {
    Parameter = "Parameter",
    Variables = "Variables",
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export class ProjectDto implements IProjectDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    data!: any | undefined;
    constructionSites!: ConstructionSiteDto[] | undefined;
    clientId!: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.data = _data["data"];
            if (Array.isArray(_data["constructionSites"])) {
                this.constructionSites = [] as any;
                for (let item of _data["constructionSites"])
                    this.constructionSites!.push(ConstructionSiteDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        data["data"] = this.data;
        if (Array.isArray(this.constructionSites)) {
            data["constructionSites"] = [];
            for (let item of this.constructionSites)
                data["constructionSites"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IProjectDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    data: any | undefined;
    constructionSites: ConstructionSiteDto[] | undefined;
    clientId: number;
}

export enum RecordCategory {
    ImportantDocs = "ImportantDocs",
    Record = "Record",
    Expense = "Expense",
    Other = "Other",
}

export class RecordDocumentDto implements IRecordDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    recordId!: number;

    constructor(data?: IRecordDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): RecordDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["recordId"] = this.recordId;
        return data;
    }
}

export interface IRecordDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    recordId: number;
}

export class RecordDto implements IRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
}

export class SectionParameter implements ISectionParameter {
    unitType!: UnitType;
    refType!: ParameterRefType;
    value!: string | undefined;

    constructor(data?: ISectionParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.refType = _data["refType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SectionParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SectionParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["refType"] = this.refType;
        data["value"] = this.value;
        return data;
    }
}

export interface ISectionParameter {
    unitType: UnitType;
    refType: ParameterRefType;
    value: string | undefined;
}

export enum SectionType {
    Line = "Line",
    Circle = "Circle",
}

export enum StatGranulation {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export class SumsDto implements ISumsDto {
    date!: Date;
    value!: number;

    constructor(data?: ISumsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SumsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SumsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ISumsDto {
    date: Date;
    value: number;
}

export enum SumType {
    Monthly = "Monthly",
    Weekly = "Weekly",
}

export class TimeAlarmDto implements ITimeAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;
    ringDate!: Date | undefined;
    inTimeRing!: AlarmTimeSpan;

    constructor(data?: ITimeAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
            this.ringDate = _data["ringDate"] ? new Date(_data["ringDate"].toString()) : <any>undefined;
            this.inTimeRing = _data["inTimeRing"] ? AlarmTimeSpan.fromJS(_data["inTimeRing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        data["ringDate"] = this.ringDate ? this.ringDate.toISOString() : <any>undefined;
        data["inTimeRing"] = this.inTimeRing ? this.inTimeRing.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
    ringDate: Date | undefined;
    inTimeRing: AlarmTimeSpan;
}

export class TimePointNumberStat implements ITimePointNumberStat {
    date!: Date;
    quantity!: number;

    constructor(data?: ITimePointNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TimePointNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new TimePointNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ITimePointNumberStat {
    date: Date;
    quantity: number;
}

export class TimePointUserNumberStat implements ITimePointUserNumberStat {
    date!: Date;
    statByUser!: { [key: string]: number; } | undefined;

    constructor(data?: ITimePointUserNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (_data["statByUser"]) {
                this.statByUser = {} as any;
                for (let key in _data["statByUser"]) {
                    if (_data["statByUser"].hasOwnProperty(key))
                        (<any>this.statByUser)![key] = _data["statByUser"][key];
                }
            }
        }
    }

    static fromJS(data: any): TimePointUserNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new TimePointUserNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.statByUser) {
            data["statByUser"] = {};
            for (let key in this.statByUser) {
                if (this.statByUser.hasOwnProperty(key))
                    (<any>data["statByUser"])[key] = (<any>this.statByUser)[key];
            }
        }
        return data;
    }
}

export interface ITimePointUserNumberStat {
    date: Date;
    statByUser: { [key: string]: number; } | undefined;
}

export class TrailerDto implements ITrailerDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    productionDate!: Date;
    data!: any | undefined;
    trailerType!: TrailerType;

    constructor(data?: ITrailerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.trailerType = _data["trailerType"];
        }
    }

    static fromJS(data: any): TrailerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrailerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["trailerType"] = this.trailerType;
        return data;
    }
}

export interface ITrailerDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    productionDate: Date;
    data: any | undefined;
    trailerType: TrailerType;
}

export enum TrailerType {
    RegularTrailer = "RegularTrailer",
    SemiTrailer = "SemiTrailer",
}

export class TransportWarrantDto implements ITransportWarrantDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    isDone!: boolean;
    startingTime!: Date;
    endingTime!: Date;
    startingKm!: number | undefined;
    endingKm!: number | undefined;
    data!: any | undefined;
    compositionId!: number;
    composition!: CompositionDto;
    driverJobPositionIds!: number[] | undefined;
    transportWarrantItems!: TransportWarrantItemDto[] | undefined;

    constructor(data?: ITransportWarrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.isDone = _data["isDone"];
            this.startingTime = _data["startingTime"] ? new Date(_data["startingTime"].toString()) : <any>undefined;
            this.endingTime = _data["endingTime"] ? new Date(_data["endingTime"].toString()) : <any>undefined;
            this.startingKm = _data["startingKm"];
            this.endingKm = _data["endingKm"];
            this.data = _data["data"];
            this.compositionId = _data["compositionId"];
            this.composition = _data["composition"] ? CompositionDto.fromJS(_data["composition"]) : <any>undefined;
            if (Array.isArray(_data["driverJobPositionIds"])) {
                this.driverJobPositionIds = [] as any;
                for (let item of _data["driverJobPositionIds"])
                    this.driverJobPositionIds!.push(item);
            }
            if (Array.isArray(_data["transportWarrantItems"])) {
                this.transportWarrantItems = [] as any;
                for (let item of _data["transportWarrantItems"])
                    this.transportWarrantItems!.push(TransportWarrantItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransportWarrantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportWarrantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["isDone"] = this.isDone;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString() : <any>undefined;
        data["endingTime"] = this.endingTime ? this.endingTime.toISOString() : <any>undefined;
        data["startingKm"] = this.startingKm;
        data["endingKm"] = this.endingKm;
        data["data"] = this.data;
        data["compositionId"] = this.compositionId;
        data["composition"] = this.composition ? this.composition.toJSON() : <any>undefined;
        if (Array.isArray(this.driverJobPositionIds)) {
            data["driverJobPositionIds"] = [];
            for (let item of this.driverJobPositionIds)
                data["driverJobPositionIds"].push(item);
        }
        if (Array.isArray(this.transportWarrantItems)) {
            data["transportWarrantItems"] = [];
            for (let item of this.transportWarrantItems)
                data["transportWarrantItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransportWarrantDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    isDone: boolean;
    startingTime: Date;
    endingTime: Date;
    startingKm: number | undefined;
    endingKm: number | undefined;
    data: any | undefined;
    compositionId: number;
    composition: CompositionDto;
    driverJobPositionIds: number[] | undefined;
    transportWarrantItems: TransportWarrantItemDto[] | undefined;
}

export class TransportWarrantItemDto implements ITransportWarrantItemDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    transportWarrantId!: number;
    constructionSiteId!: number;
    invoiceId!: number;

    constructor(data?: ITransportWarrantItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.transportWarrantId = _data["transportWarrantId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.invoiceId = _data["invoiceId"];
        }
    }

    static fromJS(data: any): TransportWarrantItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportWarrantItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["transportWarrantId"] = this.transportWarrantId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["invoiceId"] = this.invoiceId;
        return data;
    }
}

export interface ITransportWarrantItemDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    transportWarrantId: number;
    constructionSiteId: number;
    invoiceId: number;
}

export class TravelWarrantDto implements ITravelWarrantDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    isDone!: boolean;
    startingTime!: Date;
    endingTime!: Date;
    startingKm!: number | undefined;
    endingKm!: number | undefined;
    data!: any | undefined;
    carId!: number;

    constructor(data?: ITravelWarrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.isDone = _data["isDone"];
            this.startingTime = _data["startingTime"] ? new Date(_data["startingTime"].toString()) : <any>undefined;
            this.endingTime = _data["endingTime"] ? new Date(_data["endingTime"].toString()) : <any>undefined;
            this.startingKm = _data["startingKm"];
            this.endingKm = _data["endingKm"];
            this.data = _data["data"];
            this.carId = _data["carId"];
        }
    }

    static fromJS(data: any): TravelWarrantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelWarrantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["isDone"] = this.isDone;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString() : <any>undefined;
        data["endingTime"] = this.endingTime ? this.endingTime.toISOString() : <any>undefined;
        data["startingKm"] = this.startingKm;
        data["endingKm"] = this.endingKm;
        data["data"] = this.data;
        data["carId"] = this.carId;
        return data;
    }
}

export interface ITravelWarrantDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    isDone: boolean;
    startingTime: Date;
    endingTime: Date;
    startingKm: number | undefined;
    endingKm: number | undefined;
    data: any | undefined;
    carId: number;
}

export class TruckDto implements ITruckDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    productionDate!: Date;
    data!: any | undefined;
    engineType!: EngineType;
    truckType!: TruckType;

    constructor(data?: ITruckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.engineType = _data["engineType"];
            this.truckType = _data["truckType"];
        }
    }

    static fromJS(data: any): TruckDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["engineType"] = this.engineType;
        data["truckType"] = this.truckType;
        return data;
    }
}

export interface ITruckDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    productionDate: Date;
    data: any | undefined;
    engineType: EngineType;
    truckType: TruckType;
}

export enum TruckType {
    PickUp = "PickUp",
    Van = "Van",
    RegularTruck = "RegularTruck",
    SemiTrailerTruck = "SemiTrailerTruck",
}

export class UnauthorizedRequestResponse implements IUnauthorizedRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IUnauthorizedRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): UnauthorizedRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnauthorizedRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IUnauthorizedRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export enum UnitType {
    Length = "Length",
    Angle = "Angle",
}

export class VariableAngle implements IVariableAngle {
    refType!: ParameterRefType;
    value!: string | undefined;
    offsetType!: AngleOffsetType;

    constructor(data?: IVariableAngle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refType = _data["refType"];
            this.value = _data["value"];
            this.offsetType = _data["offsetType"];
        }
    }

    static fromJS(data: any): VariableAngle {
        data = typeof data === 'object' ? data : {};
        let result = new VariableAngle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refType"] = this.refType;
        data["value"] = this.value;
        data["offsetType"] = this.offsetType;
        return data;
    }
}

export interface IVariableAngle {
    refType: ParameterRefType;
    value: string | undefined;
    offsetType: AngleOffsetType;
}

export class VariableLength implements IVariableLength {
    refType!: ParameterRefType;
    value!: string | undefined;

    constructor(data?: IVariableLength) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refType = _data["refType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VariableLength {
        data = typeof data === 'object' ? data : {};
        let result = new VariableLength();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refType"] = this.refType;
        data["value"] = this.value;
        return data;
    }
}

export interface IVariableLength {
    refType: ParameterRefType;
    value: string | undefined;
}

export enum VariableType {
    Referent = "Referent",
    Embedded = "Embedded",
}

export class VehicleDocumentDto implements IVehicleDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    vehicleId!: number;

    constructor(data?: IVehicleDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    vehicleId: number;
}

export class VehicleDto implements IVehicleDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    productionDate!: Date;
    data!: any | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IVehicleDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    productionDate: Date;
    data: any | undefined;
}

export class VehicleExpenseDto implements IVehicleExpenseDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    price!: number;
    liters!: number | undefined;
    pricePerLiter!: number | undefined;
    fuelLoadAt!: number | undefined;
    isPartTimeExpense!: boolean;
    expenseType!: ExpenseType;
    vehicleId!: number;

    constructor(data?: IVehicleExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.price = _data["price"];
            this.liters = _data["liters"];
            this.pricePerLiter = _data["pricePerLiter"];
            this.fuelLoadAt = _data["fuelLoadAt"];
            this.isPartTimeExpense = _data["isPartTimeExpense"];
            this.expenseType = _data["expenseType"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["liters"] = this.liters;
        data["pricePerLiter"] = this.pricePerLiter;
        data["fuelLoadAt"] = this.fuelLoadAt;
        data["isPartTimeExpense"] = this.isPartTimeExpense;
        data["expenseType"] = this.expenseType;
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleExpenseDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    price: number;
    liters: number | undefined;
    pricePerLiter: number | undefined;
    fuelLoadAt: number | undefined;
    isPartTimeExpense: boolean;
    expenseType: ExpenseType;
    vehicleId: number;
}

export class VehicleRecordDto implements IVehicleRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    vehicleId!: number;

    constructor(data?: IVehicleRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    vehicleId: number;
}

export class WorkingMachineDto implements IWorkingMachineDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    nickname!: string | undefined;
    chassisNumber!: string | undefined;
    machineType!: MachineType;
    productionDate!: Date;
    data!: any | undefined;
    engineType!: EngineType;

    constructor(data?: IWorkingMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.nickname = _data["nickname"];
            this.chassisNumber = _data["chassisNumber"];
            this.machineType = _data["machineType"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): WorkingMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["nickname"] = this.nickname;
        data["chassisNumber"] = this.chassisNumber;
        data["machineType"] = this.machineType;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface IWorkingMachineDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    nickname: string | undefined;
    chassisNumber: string | undefined;
    machineType: MachineType;
    productionDate: Date;
    data: any | undefined;
    engineType: EngineType;
}

export class WorkingToolDocumentDto implements IWorkingToolDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    workingToolId!: number;

    constructor(data?: IWorkingToolDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    workingToolId: number;
}

export class WorkingToolDto implements IWorkingToolDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    nickname!: string | undefined;
    chassisNumber!: string | undefined;
    machineType!: MachineType;
    productionDate!: Date;
    data!: any | undefined;

    constructor(data?: IWorkingToolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.nickname = _data["nickname"];
            this.chassisNumber = _data["chassisNumber"];
            this.machineType = _data["machineType"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): WorkingToolDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["nickname"] = this.nickname;
        data["chassisNumber"] = this.chassisNumber;
        data["machineType"] = this.machineType;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IWorkingToolDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    nickname: string | undefined;
    chassisNumber: string | undefined;
    machineType: MachineType;
    productionDate: Date;
    data: any | undefined;
}

export class WorkingToolExpenseDto implements IWorkingToolExpenseDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    price!: number;
    liters!: number | undefined;
    pricePerLiter!: number | undefined;
    fuelLoadAt!: number | undefined;
    isPartTimeExpense!: boolean;
    expenseType!: ExpenseType;
    workingToolId!: number;

    constructor(data?: IWorkingToolExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.price = _data["price"];
            this.liters = _data["liters"];
            this.pricePerLiter = _data["pricePerLiter"];
            this.fuelLoadAt = _data["fuelLoadAt"];
            this.isPartTimeExpense = _data["isPartTimeExpense"];
            this.expenseType = _data["expenseType"];
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["liters"] = this.liters;
        data["pricePerLiter"] = this.pricePerLiter;
        data["fuelLoadAt"] = this.fuelLoadAt;
        data["isPartTimeExpense"] = this.isPartTimeExpense;
        data["expenseType"] = this.expenseType;
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolExpenseDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    price: number;
    liters: number | undefined;
    pricePerLiter: number | undefined;
    fuelLoadAt: number | undefined;
    isPartTimeExpense: boolean;
    expenseType: ExpenseType;
    workingToolId: number;
}

export class WorkingToolRecordDto implements IWorkingToolRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    workingToolId!: number;

    constructor(data?: IWorkingToolRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    workingToolId: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}